import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { isDark } from '../common/utils';
import styles from './circular-progress.module.scss';
const CircularProgress = ({ size = 'sm', style = 'default', }) => {
    const isDarkMode = useMemo(() => isDark(), []);
    const wrapperClass = useMemo(() => {
        return classNames(styles.circular_progress, styles[`circular_progress_${size}`], {
            [styles.dark]: isDarkMode,
        });
    }, []);
    return (_jsx("span", { className: wrapperClass, children: style === 'default' && (_jsx("span", { className: classNames(styles.inner_circle_2, {
                [styles.dark]: isDarkMode,
            }) })) }));
};
export { CircularProgress };
